export enum InvoicesErrors {
  NO_INVOICES_SELECTED = 'No invoices were selected',
  NO_SERVICE_STYLES = 'An error occured',
  NO_INVOICE_GUID = 'No invoice GUID was found',
}
